/* tslint:disable:max-line-length */
/**
 * All endpoints in use by sam-licensing should be enumerated here.
 */
export enum ApiEndpoint {
  TENANT_LICENSE = 'license-repo?size=:size',
  UUID_LICENSE = 'uuid',
  UUID_LICENSE_DELETE = 'uuid/:uuid',
  TENANT_LICENSE_UPDATE = 'license-repo/:tenantId',
  USER_LICENSE = 'license-repo/:tenantId/registeredLicenseUsersLogged',
  USER_LICENSE_DELETE = 'license-user-repo/:userId',
  OPTION_LICENSE = 'license-repo/:tenantId/optionList',
  OPTION_LICENSE_UPDATE = 'license-option-repo',
  OPTION_LICENSE_DELETE = 'license-option-repo/:optionId',
}
